export default "__VITE_ASSET__a4daeaa2__"